<script setup>
import BrandComponent from './BrandComponent.vue'

</script>

<template>
  <nav class="navbar bg-black ff-monospace">
    <div class="container">

      <brand-component></brand-component>
      
    </div>
  </nav>
</template>